// Asset paths - all assets should be stored in public/assets
export const ASSETS = {
  images: {
    defaultAvatar: '/assets/images/default-avatar.svg',
    loginBackground: '/assets/images/login-background.png',
  },
  icons: {
    eyeOpen: '/assets/icons/eye-open.svg',
    eyeClosed: '/assets/icons/eye-closed.svg',
    createUser: {
      camera: '/assets/icons/create-user/primary_photo.svg',
      person: '/assets/icons/create-user/person.png',
      workBag: '/assets/icons/create-user/work-bag.png',
      lifestyleTree: '/assets/icons/create-user/lifestyle-tree.png',
    },
    leads: {
      menu: '/assets/icons/leads/menu.svg',
      contact: '/assets/icons/leads/contact.svg',
      source: '/assets/icons/leads/source.svg',
      assignment: '/assets/icons/leads/assignment.svg',
    },
    kanban: {
      menu: '/assets/icons/kanban/menu.svg',
    },
  },
} as const;

